<script>
import HelpRequestedNotification from '@/launcher/components/shared/notifications/HelpRequestedNotification';
import CallHelpBtnConnected from '../connected/ui/CallHelpBtnConnected';

export default {
  name: 'ThanksBox',
  props: {
    organization: {
      required: true,
    },
    hasCalledHelp: {
      required: true,
    },
  },
  components: {
    CallHelpBtnConnected,
    HelpRequestedNotification,
  },
};
</script>

<template lang="pug">
  div.thanks-box.bg-black-overlay.flex.flex-column.white.relative._collision
    header.cf.pa4.flex-auto.tc
      div(v-if="organization")
        i18n.title.fw7.f3.mv3(path="Thank you for playing at {arcade}", tag="h1")
          span(place="arcade") #[br]{{ organization.name }}!
        h2.subtitle.f6.mv4 {{ $t('See you next time') }}
    div.buttons.flex.flex-wrap
      CallHelpBtnConnected.helpbtn.w-100.db.f6
    .helprequested.left-50.translate-x--50.absolute
      HelpRequestedNotification.ph3(v-show="hasCalledHelp")

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.thanks-box {
  & .helprequested {
    bottom: -4rem;
  }
}
</style>
